import { get } from "../../axios"

export function frontConfig(){

    return get("config/front")
}


// WEBPACK FOOTER //
// ./src/api/config/index.js